import { createContext, useContext, useState, ReactNode, FC } from 'react';

interface PanelDialogContextType {
    panelDialogState: boolean;
    setPanelDialogState: (state: boolean) => void;
    hasPanel: boolean;
}

const PanelDialogContext = createContext<PanelDialogContextType | undefined>(undefined);

export const PanelDialogProvider: FC<{ children: ReactNode; hasPanel?: boolean }> = ({
    children,
    hasPanel = false,
}) => {
    const [panelDialogState, setPanelDialogState] = useState(false);

    return (
        <PanelDialogContext.Provider value={{ panelDialogState, setPanelDialogState, hasPanel }}>
            {children}
        </PanelDialogContext.Provider>
    );
};

export const usePanelDialog = () => {
    const context = useContext(PanelDialogContext);
    if (context === undefined) {
        throw new Error('usePanelDialog must be used within a PanelDialogProvider');
    }
    return context;
};
